module.exports = __webpack_public_path__ + "static/media/S2N5-4.98ebb7a4.svg";